<template>
  <div id="app">
    <loading v-show="isLoading" />
    <the-header class="fixed w-full z-50 h-12" />
    <div class="container max-w-full">
      <router-view class="pt-12" />
    </div>
    <the-footer />
  </div>
</template>

<script>
import store from './store';
import { mapGetters } from 'vuex'
import './assets/common.css'
import './assets/stylesheets/main.scss'
import './assets/menu.scss'
import Constants from './constants'

import TheHeader from './components/organisms/TheHeader.vue'
import TheFooter from './components/organisms/TheFooter.vue'
import Loading from './components/organisms/Loading.vue'

export default {
  name: 'App',
  components: {
    TheHeader,
    TheFooter,
    Loading
  },
  computed: {
    ...mapGetters({
      isLoading: 'loading/isLoading'
    }),
  },
  created () {
    if (this.$route.params.lang) {
      store.dispatch('user/setLang', this.$route.params.lang)
    } else {
      store.dispatch('user/setLang', 'ja')
    }
    this.$store.dispatch('translation/fetchAll')
      .then(() => {
        const translation = this.$store.getters['translation/getTranslation']()
        for (let lang in translation) {
          this.$i18n.mergeLocaleMessage(lang, translation[lang])
        }
      })
  },
  methods : {
    createTitleDesc : function(){
      // タイトルを設定
      document.title = Constants.SITE_TITLE
    }
  },
  mounted : function(){
    this.createTitleDesc();
  }
}
</script>
